import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

import { getShortName } from '@utils/Util';

const SetStyleSubCategory = ({ product }) => {
	const renderSetStyleSubCategory = () => {
		let subCategoryList = product?.setMemberProducts?.map((item) => item.subCategory);
		return [...new Set(subCategoryList)]?.map((item, index) => (
			<li key={`subCategory_${index}`}>
				<Tooltip title={item} placement="top" arrow>
					<span>{getShortName(item, 25)}</span>
				</Tooltip>
			</li>
		));
	};

	return renderSetStyleSubCategory();
};

export default SetStyleSubCategory;
